import { cn } from "@thilke/ui/lib/utils";
import { ChevronRight, File, Folder } from "lucide-react";
import type * as React from "react";

function FileTreeBlock({
  className,
  ...props
}: React.ComponentProps<"section">) {
  return (
    <section
      data-slot="file-tree-block"
      className={cn("rounded-lg border bg-card p-3", className)}
      {...props}
    >
      <div className="mb-2 text-sm font-semibold">Registry tree</div>
      <div className="grid gap-1 text-sm">
        <div className="flex items-center gap-1.5">
          <ChevronRight className="size-3" />
          <Folder className="size-4 text-muted-foreground" /> packages/ui
        </div>
        {[
          "components/counter.tsx",
          "blocks/repo-card-block.tsx",
          "blocks/server-log-block.tsx",
        ].map((file) => (
          <div
            key={file}
            className="ml-5 flex items-center gap-1.5 text-muted-foreground"
          >
            <File className="size-4" /> {file}
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-muted-foreground">
        Repository and documentation navigation.
      </p>
    </section>
  );
}

export { FileTreeBlock };
